(function($, undefined) {
	'use strict';
    
	var galleryImg;
	var closeFullscreenBtn;
    var viewingImg;

	var initGallerySlider = function() {
		$('.gallery-com-ctn.ver1 .gallery-com-images-ctn').each(function() {
			var t = $(this);

			t.slick({
				dots: false,
				arrows: true,
				prevArrow: t.find('.arrow-btn.prev'),
				nextArrow: t.find('.arrow-btn.next'),
				slide: '.gallery-one-image',
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			}).fadeIn();
		});
	};

	var showImgFullscreen = function() {
		var t = $(this);
		var ctn = t.closest('.gallery-com-ctn').find('.fullscreen-img-ctn');

		ctn.find('.fullscreen-img').attr('style', t.attr('style'));
		ctn.addClass('open');
        viewingImg = this;
	};

	var closeFullscreen = function() {
		$(this).closest('.fullscreen-img-ctn').removeClass('open');
        viewingImg = null;
		setTimeout(function() {
			$('.fullscreen-img').removeAttr('style');
		}, 300);
	};
    
    var nextImg = function() {
        var t = $(this);
        var el = $(viewingImg).closest('.gallery-one-image');
        var img;
        
        if (t.hasClass('prev')) {
            if (el.prev()[0]) {
                img = el.prev();
            } else {
                img = el.parent().children(':last');
            }
        } else {
            if (el.next()[0]) {
                img = el.next();
            } else {
                img = el.parent().children(':first');
            }
        }
        if (img && img[0]) {
            viewingImg = img.children()[0];
            t.closest('.fullscreen-img-ctn').find('.fullscreen-img').attr('style', viewingImg.getAttribute('style'));
        }
    };

	var init = function() {
		initGallerySlider();
		galleryImg = $('.gallery-one-image-inner:not(.text-only)');
		closeFullscreenBtn = $('.close-image-fullscreen-btn');

		galleryImg.click(showImgFullscreen);
		closeFullscreenBtn.click(closeFullscreen);
        $('.gallery-fullscreen-nav').click(nextImg);
	};
	
	$(window).ready(init);

})(jQuery);

